import transliterate from '@sindresorhus/transliterate';
import filenamify from 'filenamify/browser';
export function sanitizeFilename(filename) {
    return filenamify(transliterate(filename), { replacement: '-' });
}
